import { render, staticRenderFns } from "./whatIsItForCard.vue?vue&type=template&id=7af32de1&scoped=true&"
import script from "./whatIsItForCard.vue?vue&type=script&lang=js&"
export * from "./whatIsItForCard.vue?vue&type=script&lang=js&"
import style0 from "./whatIsItForCard.vue?vue&type=style&index=0&id=7af32de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af32de1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af32de1')) {
      api.createRecord('7af32de1', component.options)
    } else {
      api.reload('7af32de1', component.options)
    }
    module.hot.accept("./whatIsItForCard.vue?vue&type=template&id=7af32de1&scoped=true&", function () {
      api.rerender('7af32de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/whatIsItForCard.vue"
export default component.exports